import { Container } from '@/components/container';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <div className="flex flex-col md:flex-row justify-center md:justify-between items-center gap-3 py-5">
          <div className="flex order-2 md:order-1  gap-2 font-normal text-2sm">
            <span className="text-gray-500 dark:text-white/60 contrast:text-white">
              {currentYear} &copy;
            </span>
            <a
              href="/"
              target="_blank"
              className="text-gray-600 dark:text-white/80 hover:text-primary dark:hover:text-white contrast:text-white hover:contrast:text-gray-800"
            >
              Saaristo Admin Panel
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export { Footer };
